var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text_right"},[_c('a',{staticClass:"btn red btn_mid pointer no-drag",on:{"click":_vm.deleteAccount}},[_vm._v("\n    "+_vm._s(_vm.$t('status.delete'))+"\n  ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }